<template>
    <ul class="c-primary-nav__list-right js-nav-panel" role="tablist" aria-multiselectable="true"> <!-- tab list -->

        <li class="c-primary-nav__item">
            <div class="c-primary-nav__link" role="button">
                <svg class="c-icon c-primary-nav__icon right-margin" aria-hidden="false" @click="toggleShowMenu" data-cy="navigationDropdown">
                    <use
                        :href="`../../assets/style/ckm-style/images/icons.svg#chevron-` + (showMenu ? 'up' : 'down')"
                    />
                </svg>
            </div>
        </li>

        <div v-if="showMenu" class="fixed submenu">
            <ul class="c-primary-nav__list-right">
                <li class="c-primary-nav__subitem">
                    <router-link
                            to="/"
                            tag="a"
                            class="c-primary-nav__sublink"
                            data-cy="homeHeader"
                            exact
                        >
                            Home
                    </router-link>
                </li>
                <li class="c-primary-nav__subitem">
                    <router-link
                        v-if="isAdmin"
                        to="/admin"
                        tag="a"
                        class="c-primary-nav__sublink"
                        data-cy="adminHeader"
                        exact
                    >
                        Admin
                    </router-link>
                </li>
                <li class="c-primary-nav__subitem">
                    <a @click="logout" class="c-primary-nav__sublink" data-cy="logoutButton" style="cursor:pointer;">
                        Logout
                    </a>
                </li>
            </ul><!-- end c-primary-nav__sublist js-nav-dropdown -->
        </div>

    </ul> <!-- end tab list-->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            showMenu: false,
        }
    },
    computed:{
        ...mapGetters([
           'isAdmin'
        ]),
        selectedAccountId() {
            return this.$store.state.selectedAccountId
        }
    },
    methods: {
        toggleShowMenu() {
            this.showMenu = !this.showMenu
        },
        logout () {
            this.$store.dispatch('logout')
            this.$router.push('/login')
        }
    }
}
</script>

<style scoped>

    .right-margin {
        margin-right: 1rem;
    }

    .fixed {
        position: fixed;
    }

    .submenu {
        width: 10rem;
        right: .5rem;
        color: #2F2F2F;
        top: 4rem;
        background-color: white;
    }

</style>
